import { Outlet } from "react-router-dom";
import SidebarMenu from "./SidebarMenu";
import Topbar from "./Topbar";
import ProductGuidanceProvider from "../../features/productGuidance/ProductGuidanceProvider";

export default function AppLayout() {
  return (
    <ProductGuidanceProvider>
      <div
        className="flex h-screen w-full flex-col overflow-hidden bg-gradient-to-br from-gray-50 via-gray-100 to-gray-50"
        data-test-id="app-layout-root"
        style={{
          "--app-shell-chrome-size": "5rem",
          "--app-shell-topbar-size": "4rem",
        }}
      >
        <Topbar />

        <div className="flex flex-1 overflow-hidden">
          <div
            className="relative z-40 h-full w-[var(--app-shell-chrome-size)] flex-shrink-0 bg-[#0a322b] shadow-[10px_0_25px_-5px_rgba(0,0,0,0.25)] transition-all duration-300"
          >
            <SidebarMenu />
          </div>

          <div
            className="relative flex flex-col flex-1 h-full overflow-hidden transition-all duration-300"
          >
            <main className="flex-1 overflow-y-auto">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </ProductGuidanceProvider>
  );
}
